import { axiosInstance } from "./apiInstance";

export const getAllTagChoices = () => {
  const response = axiosInstance.get(`/api/inkle/tags/choices/`);
  return response;
};
